export const route = {
  // USER
  Autenticate: "api/User/login",
  ForgotPassword: "api/User/forgotPassword",
  ResetPassword: "api/User/resetPassword",
  UpdateUser: "api/User/updateUser",
  UpdateAnotherUser: "api/User/updateAnotherUser",
  User: "api/User",
  getPerfilName: "api/Role/GetPerfilName",
  GetListUserRole: "api/User/GetListUserRole",
  //FacebookUSer
  CarregarPorFacebookUser: "api/InstagramPage/CarregarPorFacebookUser",
  GravarInstagramPage: "api/InstagramPage/GravarInstagramPage",
  AddUserRole: "api/User/AddUserRole",
  AtualizarTokenFacebookPage: "api/InstagramPage/AtualizaTokenFacebookPage",

  //INSTAGRAM PAGE
  InstagramPage: "api/InstagramPage",
  RegisterUser: "api/user/Register",
  GetRegional: "api/InstagramPage/GetRegional",
  GetRelationship: "api/InstagramPage/GetInstagramRelationship",

  //InstagramPageInsights
  InstagramPageInsights: "api/InstagramPageInsights",

  //GetAllOrFilteredInstagrams
  GetAllOrFilteredInstagrams: "api/InstagramReport/DashBoard",

  //ReportXls
  ReportXls: "api/InstagramReport/ReportXlsV2",

  //InstagramComments
  InstagramComments: "api/InstagramComments",

  //ReplyComment
  ReplyComment: "api/InstagramComments/ReplyComment",

  //InstagramMedia
  InstagramMedia: "api/InstagramMediaV2",
  InstagramMediasScheduledMediasV2: "api/InstagramMediaV2/GetScheduledMediasV2",
  GetAllMedias: "api/InstagramMediaV2/GetAllMediasV2",

  //InstagramLibraryUpload
  InstagramLibraryUpload: "api/InstagramLibraryUpload",
  InstagramLibraryUploadGetImage: "api/InstagramLibraryUpload/GetImage",

  //api/InstagramLibraryCategory
  InstagramLibraryCategory: "api/InstagramLibraryCategory",
  GetCategoryWithMedias: "api/InstagramLibraryCategory/GetCategoryWithMedias",

  //UploadMidia
  UploadMidia: "api/UploadMidia",
  UploadFile: "api/UploadMidia/UploadFile",

  InstagramMediaScheduleV2: "api/InstagramMediaV2/SchedulePost",
  InstagramMediaGetScheduleV2: "api/InstagramMediaV2/GetScheduledMediasV2",
  InstagramPostMediaV2: "api/InstagramMediaV2/PostMedia",

  DisableUser: "api/User/DisableUser",

  //RemoveRole
  RemoveRole: "api/User/RemoveRole",
};
